import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { unbanUser } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom],
  data: function data() {
    var _this = this;

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('roleIdIncorrect')));
      } else {
        callback();
      }
    };

    return {
      dialogShow: false,
      paramsData: {
        op_type: 1
      },
      rules: {}
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.paramsData.is_abnormal_op = true;
      this.paramsData.uids = [data.uid];
      this.paramsData.server_id = data.server_id;
      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        id: this.paramsData.id,
        uids: '',
        op_type: 1
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.paramsData));
          unbanUser(_objectSpread(_objectSpread({}, data), _this2.propsData)).then(function (res) {
            if (res.code == 200 || res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change', data.uids);
            }
          }).finally(function () {
            _this2.issubmit = false;
          });
        }
      });
    }
  }
};